import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { CompanyInput } from '@fullyops/data/companies/company';

@Injectable()
export class CompanyFormService {
  fb = new UntypedFormBuilder();

  form$: ReplaySubject<UntypedFormGroup> = new ReplaySubject(1);

  constructor() {}

  initForm(draftCompany: CompanyInput, disabled: boolean, emailRequired) {
    // Required so that form$ only emits a value after this method is called.
    // This is important so that the emailRequired and bothTypeAllowed parameters are known by then.
    this.form$.next(new UntypedFormGroup({}));
  }

  getDraft(): CompanyInput {
    throw new Error(
      'This method exists only to satisfy the legacy AbstractFormService interface',
    );
  }

  markAllAsTouched(): void {
    throw new Error(
      'This method exists only to satisfy the legacy AbstractFormService interface',
    );
  }
}
